function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(14 14)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M94.946 184H71.059l-.034-7.247C70.585 66.745 76.05 0 83.038 0c6.988 0 12.457 64.414 11.926 176.753L94.946 184z"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 4,
  transform: "translate(0 58.5)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M4.5 0L4.5 68.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  d: "M0 68.5h9V104c0 2.485-2.015 4.5-4.5 4.5S0 106.485 0 104V68.5h0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M1 18.5L8 18.5M4.5 108.5L4.5 119"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  d: "M9 77L71 77 71 108.5 59.5 115 9 102z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 31,
  x: 54,
  y: 70.5,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M43 77.5L43 97M43 104.5L43 110"
}), /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 27,
  x: 55,
  y: 108.5,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M55.5 129L58 129M55.5 123L63 123M43 112.5L43 123"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#BED1FB",
  strokeLinecap: "round",
  d: "M43 134.5L43 139"
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 4,
  transform: "matrix(-1 0 0 1 166 58.5)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M4.5 0L4.5 68.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  d: "M0 68.5h9V104c0 2.485-2.015 4.5-4.5 4.5S0 106.485 0 104V68.5h0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M1 18.5L8 18.5M4.5 108.5L4.5 119"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  d: "M9 77L71 77 71 108.5 59.5 115 9 102z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 31,
  x: 54,
  y: 70.5,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M43 77.5L43 97M43 104.5L43 110"
}), /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 27,
  x: 55,
  y: 108.5,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  d: "M55.5 129L58 129M55.5 123L63 123M43 112.5L43 123"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#BED1FB",
  strokeLinecap: "round",
  d: "M43 134.5L43 139"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 105,
  r: 7,
  fill: "#5C8DF6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 229,
  r: 4,
  fill: "#5C8DF6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 187,
  r: 2,
  fill: "#5C8DF6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 210,
  r: 4,
  fill: "#5C8DF6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 178,
  r: 2,
  fill: "#5C8DF6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 200,
  r: 2,
  fill: "#5C8DF6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M18.392 31.329c-.742-.226-1.16-1.011-.934-1.753.136-.448.486-.798.934-.934 2.743-.837 4.866-3.021 5.623-5.787l.127-.463c.203-.742.97-1.179 1.711-.976.475.13.846.501.976.976l.127.463c.757 2.766 2.88 4.95 5.623 5.787.742.226 1.16 1.01.934 1.753-.137.447-.487.797-.934.934-2.755.84-4.91 2.995-5.75 5.75-.226.742-1.011 1.16-1.753.934-.448-.137-.798-.487-.934-.934-.84-2.755-2.996-4.91-5.75-5.75zM32.82 53.086c-.437-.133-.683-.596-.55-1.033.08-.263.287-.47.55-.55 1.616-.493 2.867-1.78 3.314-3.41l.074-.273c.12-.437.572-.694 1.009-.575.28.077.498.295.575.575l.074.273c.447 1.63 1.698 2.917 3.314 3.41.437.133.683.596.55 1.033-.08.264-.287.47-.55.55-1.623.495-2.893 1.765-3.388 3.389-.134.437-.596.683-1.033.55-.264-.08-.47-.287-.55-.55-.496-1.624-1.766-2.894-3.389-3.389zM137.82 86.086c-.437-.133-.683-.596-.55-1.033.08-.263.287-.47.55-.55 1.616-.493 2.867-1.78 3.314-3.41l.074-.273c.12-.437.572-.694 1.009-.575.28.077.498.295.575.575l.074.273c.447 1.63 1.698 2.917 3.314 3.41.437.133.683.596.55 1.033-.08.264-.287.47-.55.55-1.623.495-2.893 1.765-3.388 3.389-.134.437-.596.683-1.033.55-.264-.08-.47-.287-.55-.55-.496-1.624-1.766-2.894-3.389-3.389z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 56,
  x: 79,
  y: 120,
  fill: "#BED1FB",
  stroke: "#5C8DF6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5C8DF6",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M77 25L88.5 25M83 31L83 50.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#BED1FB",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M83 57L83 61.5"
}));

var SvgSpaceship = function SvgSpaceship(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 261,
    viewBox: "0 0 194 261",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpaceship, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spaceship.db00510a.svg";
export { ForwardRef as ReactComponent };